export default __webpack_public_path__ + "static/media/react-bootstrap.1c7d4dd1.svg";